import React, { useMemo } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import ModalChildrenContainer from '../../../../Atoms/Modal/ModalChildrenContainer';
import TextInput from '../../../../Atoms/Inputs/TextInput';
import LoaderButton from '../../../../Molecules/Loader/LoaderButton';
import Buttons from '../../../../Atoms/Buttons/Buttons';
import Modal from '../../../../Atoms/Modal/Modal';
import { useToast } from '../../../../Molecules/Custom/CustomToaster/Toast';

import hashIcon from '../../../../../assets/icons/formActions/inputs/hash.svg';

const toNum = (v) => {
  const n = Number(String(v ?? '').replace(/[^\d.-]/g, ''));
  return Number.isFinite(n) ? n : 0;
};

const asStr = (v) => (v === undefined || v === null ? '' : String(v));

const numSchema = Yup.number()
  .typeError('الرجاء إدخال رقم صحيح')
  .min(0, 'لا يمكن أن يكون الرقم سالباً')
  .required('هذا الحقل مطلوب');

const ManageCandidatesBatchesModal = ({
  handleOnClose,
  initialData, // optional: { maleCandidates, femaleCandidates, totalBatches }
  onSave, // optional async: (payload) => Promise
  isLoading = false, // optional if you manage loading in parent/hook
}) => {
  const toast = useToast();

  const initialValues = useMemo(() => {
    return {
      maleCandidates: asStr(initialData?.maleCandidates ?? ''),
      femaleCandidates: asStr(initialData?.femaleCandidates ?? ''),
      totalBatches: asStr(initialData?.totalBatches ?? ''),
    };
  }, [initialData]);

  const validationSchema = Yup.object().shape({
    maleCandidates: numSchema,
    femaleCandidates: numSchema,
    totalBatches: numSchema,
  });

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={async (values) => {
        const payload = {
          maleCandidates: toNum(values.maleCandidates),
          femaleCandidates: toNum(values.femaleCandidates),
          totalBatches: toNum(values.totalBatches),
        };

        try {
          if (onSave) await onSave(payload);

          toast.open('تم الحفظ بنجاح');
          handleOnClose?.();
        } catch (e) {
          console.error(e);
          toast.open('حدث خطأ أثناء الحفظ');
        }
      }}
    >
      {({ values, errors, touched, setFieldValue, handleSubmit }) => {
        return (
          <Form>
            <Modal
              onClose={handleOnClose}
              title='إدارة المرشحين والدفعات'
              width='40%'
              closeWhite={false}
            >
              <ModalChildrenContainer noOverflow>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1.2rem',
                    direction: 'rtl',
                  }}
                >
                  <TextInput
                    label='المرشحين'
                    icon={hashIcon}
                    name='maleCandidates'
                    placeholder='ادخل الرقم'
                    value={values.maleCandidates}
                    required
                    onChange={(name, value) => setFieldValue(name, value)}
                    errors={errors.maleCandidates}
                    touched={touched.maleCandidates}
                    left
                  />

                  <TextInput
                    label='المرشحات'
                    icon={hashIcon}
                    name='femaleCandidates'
                    placeholder='ادخل الرقم'
                    value={values.femaleCandidates}
                    required
                    onChange={(name, value) => setFieldValue(name, value)}
                    errors={errors.femaleCandidates}
                    touched={touched.femaleCandidates}
                    left
                  />

                  <TextInput
                    label='إجمالي الدفعات'
                    icon={hashIcon}
                    name='totalBatches'
                    placeholder='ادخل الرقم'
                    value={values.totalBatches}
                    required
                    onChange={(name, value) => setFieldValue(name, value)}
                    errors={errors.totalBatches}
                    touched={touched.totalBatches}
                    left
                  />

                  {isLoading ? (
                    <LoaderButton />
                  ) : (
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gap: '1rem',
                        marginTop: '0.6rem',
                      }}
                    >
                      <button
                        type='button'
                        onClick={handleOnClose}
                        style={{
                          height: '46px',
                          borderRadius: '999px',
                          border: '0',
                          background: '#bdbdbd',
                          color: '#fff',
                          fontWeight: 700,
                          cursor: 'pointer',
                        }}
                      >
                        إلغاء
                      </button>

                      <Buttons
                        text='حفظ'
                        handleOnClick={handleSubmit}
                        rounded
                      />
                    </div>
                  )}
                </div>
              </ModalChildrenContainer>
            </Modal>
          </Form>
        );
      }}
    </Formik>
  );
};

export default ManageCandidatesBatchesModal;
